import { Link } from 'react-router-dom';

import { ROUTES } from '../../core/constants/routes';
import { meta } from '../../global/config/api';
import CHANGELOG from './changelog';

import './styles/footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const CURRENT_YEAR = new Date().getFullYear();

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer__inner">
                <div className="footer__brand">
                    <img className="footer__logo" src="/logo.png" alt={meta.projectName} />
                    <p className="footer__disclaimer">
                        Producto de demostración. Los sorteos, los números vendidos y los pagos
                        se simulan en el navegador: no hay dinero real ni apuestas de verdad.
                    </p>
                </div>

                <nav className="footer__links">
                    <Link className="footer__link" to={ROUTES.HOME}>Inicio</Link>
                    <Link className="footer__link" to={ROUTES.STORE}>Tienda</Link>
                    <Link className="footer__link" to={ROUTES.TICKETS}>Mis números</Link>
                    <Link className="footer__link" to={ROUTES.CHANGELOG}>Cambios {CURRENT_VERSION}</Link>
                </nav>
            </div>

            <div className="footer__legal">
                <span>© {CURRENT_YEAR} {meta.projectName}</span>
                <span className="footer__version">{CURRENT_VERSION}</span>
            </div>
        </footer>
    );
}
